var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOlympusArbitrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 433",
    fill: "rgba(255,255,255,0)",
    d: "M4 4h22v22H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1632",
    d: "M12.622 25.026v-3.857a7.059 7.059 0 0 1-5-6.7 7.129 7.129 0 0 1 7.22-7.035 7.129 7.129 0 0 1 7.22 7.035 7.059 7.059 0 0 1-5 6.7v3.857h7.961v-2.87h-3.929a9.656 9.656 0 0 0 3.885-7.705 9.967 9.967 0 0 0-10.136-9.789 9.967 9.967 0 0 0-10.136 9.789 9.656 9.656 0 0 0 3.885 7.706H4.661v2.869Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3e4062",
    stroke: "#1e1f37",
    transform: "translate(14 13.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 213",
    fill: "none",
    d: "M14 13.875h16v16H14z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 348",
    d: "m23.241 21.435.774-1.313 2.086 3.249v.624l-.002-4.289a.323.323 0 0 0-.149-.257l-3.756-2.16a.331.331 0 0 0-.287 0l-.034.019-.013.008-3.645 2.113-.014.006a.329.329 0 0 0-.054.031.324.324 0 0 0-.135.243l.006 3.5 1.943-3.012a1.425 1.425 0 0 1 1.272-.521l.581.015-3.422 5.487.4.232 3.463-5.714 1.531-.006-3.451 5.856 1.439.828.172.1a.33.33 0 0 0 .232 0l3.808-2.207-.728.422Zm.3 4.253-1.455-2.282.887-1.506 1.91 3.006Z",
    fill: "#2d374b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 349",
    d: "m22.086 23.406 1.454 2.282 1.343-.778-1.909-3.009Z",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M26.106 23.994v-.624l-2.086-3.249-.774 1.313 2.014 3.257.728-.422a.323.323 0 0 0 .119-.235Z",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 351",
    d: "m17.364 24.582 1.028.592 3.422-5.487-.581-.015a1.425 1.425 0 0 0-1.272.521l-1.943 3.012-.654 1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 352",
    d: "m23.789 19.687-1.531.006-3.463 5.714 1.21.7.329-.558Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 353",
    d: "M26.746 19.679a.975.975 0 0 0-.458-.784l-3.8-2.188a.99.99 0 0 0-.873 0c-.032.016-3.7 2.144-3.7 2.144a.974.974 0 0 0-.551.826v4.532l.654-1-.006-3.5a.311.311 0 0 1 0-.038.322.322 0 0 1 .13-.205c.017-.012 3.748-2.172 3.76-2.178a.331.331 0 0 1 .287 0l3.756 2.16a.323.323 0 0 1 .149.257v4.331a.316.316 0 0 1-.112.235l-.728.422-.376.218-1.343.778-1.362.789a.33.33 0 0 1-.232 0l-1.611-.927-.329.558 1.448.834.126.071.1.057a.941.941 0 0 0 .384.079.968.968 0 0 0 .355-.067l3.964-2.294a.967.967 0 0 0 .373-.729v-4.381Z",
    fill: "#96bedc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOlympusArbitrum);
export default __webpack_public_path__ + "static/media/ic_olympus_arbitrum.2d52c3f7cd3d3dc031f4da58568f3400.svg";
export { ForwardRef as ReactComponent };